import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as appointmentActions from '../../actions/appointmentActions';
import Moment from 'react-moment';
import * as constant from '../../constants/constant';
import PdfViewer from '../sitemanagement/pdfviewer';
import moment from 'moment';
import Pagination from "react-js-pagination";
// var lib = require('download-url-file'),
// downloadFile = lib.downloadFile
// import axios from 'axios';

class HealthRecord extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			userName: '',
			image: '',
			userPassword: '',
			appointmentsList: [],
			pdfviewer: false,
			activePage: 1,
			count: 10,
			sortColumnName: '',
			sortOrder: -1,
		}
		this.verifyPassword = this.verifyPassword.bind(this)
		this.patientPassword = this.patientPassword.bind(this)
		this.loadPdfViewer = this.loadPdfViewer.bind(this)
		this.hidePdfViewerModal = this.hidePdfViewerModal.bind(this)
		this.handlePageChange = this.handlePageChange.bind(this);
		this._sortClass = this._sortClass.bind(this);
		this.sortChanged = this.sortChanged.bind(this);
		this.downloadPriscription = this.downloadPriscription.bind(this);
	}

	sortChanged(sortColumnName, order, e) {

		// e.preventDefault();

		this.state.sortColumnName = sortColumnName;
		this.state.page = 1;
		this.state.sortOrder = order == 1 ? -1 : 1;

		// let userToken = localStorage.getItem('token');
		// let patientId = localStorage.getItem('userId');
		const sorting = {}
		sorting[sortColumnName] = order.toString().toLowerCase() == 1 ? -1 : 1
		this.state.sorting = sorting;
		// let appointmentObj = {
		// 	token: userToken,
		// 	patientId: patientId,
		// 	flag: this.state.flag,
		// 	page: this.state.activePage,
		// 	count: this.state.count,
		// 	sorting: sorting,
		// 	sortOrder: this.state.sortOrder,
		// };

		// this.props.actions.getAppointments(appointmentObj);
		let data = {
			patientId: localStorage.getItem('userId'),
			count: this.state.count,
			page: 1,
			sorting: sorting,
			sortOrder: this.state.sortOrder,
		}
		this.props.actions.getAppointmentsForHealthRecord(data)

	}
	// function for set sort icon on table header
	_sortClass(filterName) {
		return "fa fa-fw " + ((filterName == this.state.sortColumnName) ? ("fa-sort-" + this.state.sortOrder) : "fa-sort");
	}
	componentWillMount() {
		let passwordData = localStorage.getItem('passwordData');
		console.log("==>passwprd", passwordData != false, passwordData)
		if (passwordData == 1) {
			let data = {
				patientId: localStorage.getItem('userId'),
				count: this.state.count,
				page: 1
			}
			this.props.actions.getAppointmentsForHealthRecord(data)
		}else{
			this.props.history.push('/dashboard/verify-user')
		}
	}
	componentWillUnmount(){
		localStorage.setItem('passwordData', 0)
	}
	downloadPriscription(url,id){
		// downloadFile(url);
		let ListData = {
			patientId: localStorage.getItem('userId'),
			count: this.state.count,
			page: this.state.activePage
		};
		this.props.actions.downloadFile(url,id,ListData);
	
	}
	handlePageChange(pageNumber) {
		this.setState({ activePage: pageNumber });
		let appointmentObj = {
			patientId: localStorage.getItem('userId'),
			count: this.state.count,
			page: pageNumber
		};
		this.props.actions.getAppointmentsForHealthRecord(appointmentObj);
	}

	componentDidMount() {
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			appointmentList: nextProps.appointmentList,
			totalCount: nextProps.totalCount
		})
		if (this.state.passwordData > 0) {

		}
	}

	verifyPassword() {
		var passwordObj = {
			password: this.state.userPassword,
			userId: localStorage.getItem('userId')
		}
		this.props.actions.verifyPassword(passwordObj)
	}

	patientPassword(event) {
		this.setState({
			userPassword: event.target.value
		})
	}

	loadPdfViewer(pdfurl) {
		console.log("pdf viewer", pdfurl)
		this.setState({
			'pdfviewer': true,
			// 'pdfurl': pdfurl
			'pdfurl': 'http://localhost:4576/uploads/5d27a10515f95102d23c0f8f/725955076338_1585480008323_consultation.pdf'
		})
	}

	hidePdfViewerModal() {
		this.setState({
			'pdfviewer': false
		})
	}
	render() {
		
		var appointmentsList = this.state.appointmentList;
		var rowsList = [];

		let userlocation = moment(new Date()).tz(moment.tz.guess()).format('z');

		console.log("+++++++++++++++++++++++++++++++>>>>>", this.state.pdfurl)
		{
			this.state.appointmentList ? this.state.appointmentList.forEach(function (item, index) {
				var splittime = item.appointmentTime.split(":")
				var hours = ('0' + splittime[0]).slice(-2)
				var min = splittime[1]
				item.appointmentTime = hours + ':' + min;
				var imageurl = item.specialistsInfo.profileImage == 'noUserImage.jpg' ? item.doctorInfo[0].gender=='Male'? constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER +constant.COMMON_FOLDER +'doctor_m.png': constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER +constant.COMMON_FOLDER +'doctor_f.png' : constant.PRODUCTION_IMAGE_URL + 'uploads/' + item.doctorId + '/' + item.specialistsInfo.profileImage;
				var prescription = item.prescription ? constant.PRODUCTION_IMAGE_URL + 'uploads/' + item.patientId + '/' + item.prescription : '';
				var consultation = item.consultation ? constant.PRODUCTION_IMAGE_URL + 'uploads/' + item.patientId + '/' + item.consultation : '';
				var defaultImagePath = item.doctorInfo[0].gender=='Male'? constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER +constant.COMMON_FOLDER +'doctor_m.png': constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER +constant.COMMON_FOLDER +'doctor_f.png';
				rowsList.push(<tr key={index} >
					<td>	<img src={imageurl} onError={(e) => { e.target.src = defaultImagePath }} /> </td>
					<td className="text-capitalize">Dr. {item.doctorInfo[0].userName}</td>
					<td> <Moment format="DD-MM-YYYY">{item.appointmentDate}</Moment></td>
					<td> {item && moment.parseZone(new Date(item.checkappointmentDate)).format('hh:mm A') + " " + userlocation}</td>
					{/* <td> {item && `${new Date(item.checkappointmentDate).getHours() <= 9 ? `0${new Date(item.checkappointmentDate).getHours()}`: new Date(item.checkappointmentDate).getHours()}:${new Date(item.checkappointmentDate).getMinutes() == 0 ? '00': `${new Date(item.checkappointmentDate).getMinutes()}`}` }</td> */}
					<td>{item && item.specializationData && item.specializationData.specialization}</td>
					<td > 
						{consultation ? <span className='tooltip-custom fadeEffect tisymtomhover' data-title="View Health Record"><Link to="/dashboard/my-health-record/pdf"><img src={require('../../images/img/book.png')} alt="" className="img-healthrecord" /></Link></span> :<span className='tooltip-custom fadeEffect tisymtomhover' data-title="View Health Record"> <img src={require('../../images/img/book.png')} alt="" className="img-healthrecord " /></span>}
						{consultation ? <span className='tooltip-custom fadeEffect tisymtomhover' data-title="Download Health Record"><a href={consultation} target="_blank"><img src={require('../../images/Download.png')} alt="" className="img-healthrecord" /></a></span> :<span className='tooltip-custom fadeEffect tisymtomhover' data-title="Download Health Record"> <Link><img src={require('../../images/Download.png')} alt="" className="img-healthrecord" /></Link></span>}
					</td>
					<td>

						{prescription  && !item.isDownloaded  ? <span className='tooltip-custom fadeEffect tisymtomhover' data-title="View Prescription"> <img src={require('../../images/img/book.png')} alt="" onClick={this.loadPdfViewer.bind(this, prescription)} className="img-healthrecord" /> </span>: <span className='tooltip-custom fadeEffect tisymtomhover' data-title="View Prescription"> <img src={require('../../images/img/book_grey.png')} alt="" className="img-healthrecord" /></span>}
						{prescription && !item.isDownloaded ?  <span className='tooltip-custom tooltipRight fadeEffect tisymtomhover' data-title="Download Prescription"><img onClick={this.downloadPriscription.bind(this,prescription,item._id)} src={require('../../images/Download.png')} alt="" className="img-healthrecord" /></span> : <span className='tooltip-custom tooltipRight fadeEffect tisymtomhover' data-title="Download Prescription"> <Link><img src={require('../../images/Download_grey.png')} alt="" className="img-healthrecord" /></Link></span>}
					</td>

				</tr >)
			}.bind(this)) : ''
		}

		return (
			<div className="content-wrapper" >
				<section className="content container-fluid">
					<div className="row">
						<div className="col-md-12">
							<div className="boxMrgB">
								<div className="nav-tabs-custom">
									<div className="tab-content" style={{ "minHeight": 410 }}>
										<div className="tab-pane active" id="tab_1">
											<div id="cbp-vm" className="cbp-vm-switcher cbp-vm-view-grid">
												<div className="mbTab">
													{this.state.pdfviewer ?
														<PdfViewer openModal={this.state.pdfviewer} hidePdfViewerModal={this.hidePdfViewerModal} pdfurl={this.state.pdfurl} />
														: ''
													}
													{/* <div className="cbpTitle cbp-vm-view-list">
														<div className="cbpTitle1"></div>
														<div className="cbpTitle2">Specialist Name</div>
														<div className="cbpTitle3">Appointment Date </div>
														<div className="cbpTitle4"> Mode </div>
														<div className="cbpTitle5">Consultation Fees </div>
														<div className="cbpTitle6">Status</div>
														<div className="cbpTitle6">&nbsp; </div>
													</div> */}
													{/* <div style={{ display: this.state.grid ? 'block' : 'none' }}>
														<ul className="row">
															{rowsGrid && rowsGrid.length > 0 ? rowsGrid : <li className="col-sm-12"><div className="gridView noUpcoming">There are no  Health Records.</div></li>}
														</ul>
													</div> */}
													<div>
														<div className="table-responsive">
															<table className="table  table-hover tableList">
																<thead>
																	<tr>
																		<th></th>
																		<th 	onClick={this.sortChanged.bind(this, 'doctorInfo.firstName', this.state.sortOrder)}>
																			Specialist Name
                                <i className={this._sortClass('appointmentspecialistname')}></i>
																		</th>
																		<th onClick={this.sortChanged.bind(this, 'appointmentDate', this.state.sortOrder)}>
																			Appointment Date
                                <i className={this._sortClass('appointmentdate')}></i>
																		</th>
																		<th onClick={this.sortChanged.bind(this, 'appointmentTime', this.state.sortOrder)}>
																			Appointment Time
                                <i className={this._sortClass('appointmentdate')}></i>
																		</th>
																		<th onClick={this.sortChanged.bind(this, 'specializationData.specialization', this.state.sortOrder)}>
																			Specialization
																	<i className={this._sortClass('appointmentspecialistname')}></i>
																		</th>
																		<th>
																			Health Record
																	{/* <i className={this._sortClass('appointmentspecialistname')}></i> */}
																		</th>
																		<th>
																			Prescription
                                {/* <i className={this._sortClass('appointmentspecialistname')}></i> */}
																		</th>
																		<th></th>
																		<th></th>
																	</tr>
																</thead>
																<tbody>{rowsList && rowsList.length > 0 ? rowsList : <tr><td colSpan={9}><p className="text-center noUpcomingTable">There are no Health Records.</p></td></tr>}</tbody>
															</table>
														</div>
													</div>

												</div>
											</div>
											{(appointmentsList && appointmentsList.length > 0) ?
												<div className="row">
													<div className="col-sm-5"><div className="showingEntries">Showing {(this.state.activePage * this.state.count) - (this.state.count - 1)} to {(this.state.activePage * this.state.count) > this.state.totalCount ? this.state.totalCount : (this.state.activePage * this.state.count)} of {this.state.totalCount} entries</div></div>
													<div className="col-sm-7 text-right" style={{ "cursor": "pointer" }}>
														<Pagination
															prevPageText='Prev'
															nextPageText='Next'
															hideFirstLastPages
															activePage={this.state.activePage}
															itemsCountPerPage={10}
															totalItemsCount={this.state.totalCount}
															pageRangeDisplayed={10}
															onChange={this.handlePageChange.bind(this)}
														/>

													</div>

												</div> : ''}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>

				<div className="Copyrightafterlogin">
				<p>Medfix &copy; 2018. All rights reserved</p>

				</div>
			</div>
		);
	}
}


//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		appointmentList: state.appointment.appointmentList ? state.appointment.appointmentList.appointmentData : '',
		totalCount: state.appointment.appointmentList ? state.appointment.appointmentList.totalCount : 0,
	};
}
//this tells what action should expose on props
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(appointmentActions, dispatch),
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(HealthRecord);